import { Column, Grid } from "@carbon/react";
import { ArrowDownLeft, ArrowUpRight } from "@carbon/react/icons";

import { Card, CurrencyDisplay, QuickSummary } from "../../components";

export const QuickSummaryColumData = () => {
  return (
    <Card>
      <Grid>
        <Column sm={0} md={4} lg={16}>
          <div className="flex-container">
            <div className="flex-box">
              <QuickSummary
                title={"Money In"}
                value={
                  <CurrencyDisplay amount="4,500,000.00" currencySymbol="₦" />
                }
                icon={
                  <div className="badge-with-icon icon-success font-ctm--regular">
                    <ArrowUpRight className="badge-icon" />
                    <span className="icon-text">24%</span>
                  </div>
                }
              />
            </div>

            <div className="flex-divider" />

            <div className="flex-box">
              <QuickSummary
                title={"Money Out"}
                value={
                  <CurrencyDisplay amount="2,300,000.00" currencySymbol="₦" />
                }
                icon={
                  <div className="badge-with-icon icon-danger font-ctm--regular">
                    <ArrowDownLeft className="badge-icon" />
                    <span className="icon-text">10%</span>
                  </div>
                }
              />
            </div>

            <div className="flex-divider" />

            <div className="flex-box">
              <QuickSummary title={"Total Transactions"} value={"57"} />
            </div>

            <div className="flex-divider" />

            <div className="flex-box">
              <QuickSummary title={"Total Successful"} value={"57"} />
            </div>

            <div className="flex-divider" />

            <div className="flex-box">
              <QuickSummary title={"Disputes"} value={"3"} />
            </div>
          </div>
        </Column>

        <Column sm={4} md={0} lg={0}>
          <Grid>
            <Column sm={4} md={4} lg={3}>
              <QuickSummary title={"Money In"} value={"₦4,500,000.00"} />
            </Column>
            <Column sm={4} md={4} lg={3}>
              <QuickSummary title={"Money Out"} value={"₦2,300,000.00"} />
            </Column>
            <Column sm={4} md={4} lg={2}>
              <QuickSummary title={"Total Transactions"} value={"57"} />
            </Column>
            <Column sm={4} md={4} lg={2}>
              <QuickSummary title={"Total Successful"} value={"57"} />
            </Column>
            <Column sm={4} md={4} lg={2}>
              <QuickSummary title={"Disputes"} value={"3"} />
            </Column>
          </Grid>
        </Column>
      </Grid>
    </Card>
  );
};
